import Handlebars from "handlebars/dist/handlebars.min.js";
import PostForm from "./PostForm";
import Analytics from "../utils/Analytics";
import Utils from "../utils/Utils";
/**
 *
 *
 * @author Jaap
 * @date 23-09-2019
 */
export default class SearchPanel extends PostForm {
    constructor(panelElement) {
        super();
        this.searchFormElement = panelElement;
        this.searchFormElement &&
            this.searchFormElement.addEventListener("submit", (e) => {
                this.submitForm(e);
            });

        this.resultHolder = document.getElementById("maglrinterface-search-results");

        this.resultHolder.addEventListener("click", (event) => this.resultClicked(event));

        const source = document.getElementById("HB-search-results").innerHTML;
        this.resultTemplate = Handlebars.compile(source);
        this.analytics = new Analytics();
    }

    submitForm(e) {
        e.preventDefault();

        let search = this.searchFormElement.querySelector("#maglrinterface-search-field");
        if (!search || !search.reportValidity()) {
            return;
        }

        //TODO: window.frontend omschrijven naar iets nets
        // get the issue_id from the FrontendController or default 'all'
        let { _issue_id: issue_id = "all" } = window.frontend;

        let formData = new FormData();
        formData.append("domain", location.hostname);
        formData.append("client_id", window.client_id);
        formData.append("issue_id", issue_id);
        formData.append("search", search.value);
        formData.append("list", Object.keys(window.issues));
        formData.append("overview", window?.interface_settings?.settings?.overview_enabled);

        // this.postForm(formData, '/s/api/search')
        this.postForm(formData, window.dash_domain + "/en_EN/api/Search.json") // tijdelijk terug gezet.
            .then((response) => {
                this.postSuccess(response);
            })
            .catch((response) => {
                this.postError(response);
            });

        this.analytics.sendEventUpdate(
            this.analytics.createUserEvent(["Interface-sidemenu", "Search-query", search.value]),
        );
    }

    postSuccess(response) {
        let raw_result, results;
        try {
            raw_result = JSON.parse(response.responseText);
            results = raw_result.message;
        } catch (e) {
            console.warn("Search response parse Error", e);
            return;
        }

        let renderData = {
            data_url: window.data_domain,
        };

        if (results.length === 0) {
            try {
                renderData.search_result_text = window.interface_settings.settings?.text?.search_noresult;
            } catch (e) {
                renderData.search_result_text = "No results";
                console.warn(e);
            }
        } else {
            try {
                renderData.search_results = results;
                renderData.search_result_text = window.interface_settings.settings?.text?.search_result;
                renderData.search_result_text = renderData.search_result_text.replace("[COUNT]", results.length);
            } catch (e) {
                console.warn(e);
            }
        }

        //tmp fix urls if we run local.
        if (!renderData.data_url) {
            for (var i in renderData.search_results) {
                renderData.search_results[i].cover = "images/" + renderData.search_results[i].spread_id + "/large.jpg";
            }
        }

        //render HB content here
        this.resultHolder.innerHTML = this.resultTemplate(renderData);
    }

    postError(result) {
        console.log(result);
    }

    resultClicked(event) {
        let target = event.target;
        if (target.dataset && target.dataset.navspread) {
            event.preventDefault();
            event.stopPropagation();
            window.dispatchEvent(
                Utils.createEvent("MaglrHistoryPush", {
                    detail: { issueId: target.dataset.navissue, spreadId: target.dataset.navspread },
                }),
            );
        }
    }
}
